import { jsx as j } from "@emotion/react/jsx-runtime";
import { useState as e, useRef as f, useLayoutEffect as w, useMemo as q, createContext as z, useContext as B } from "react";
import { registerLocale as G } from "react-datepicker";
import { DEFAULT_FORMAT_MONTH as J, DEFAULT_FORMAT_DATE as K } from "./helpers.js";
import { DatePickerType as _, DatePickerInputName as Q } from "../../types/components/dateRangePicker.js";
const g = z(void 0), $ = () => {
  const t = B(g);
  if (!t)
    throw new Error("useDatePickerContext must be used within a DatePickerProvider");
  return t;
}, tt = ({
  dataTrackId: t,
  children: k,
  dates: p,
  localeDatePicker: r,
  onChange: s,
  datePickerType: l,
  withShortcut: m = !1,
  minDate: D,
  maxDate: v,
  position: P,
  format: u,
  error: d,
  success: x,
  warning: A,
  notice: C,
  isReset: h
}) => {
  const {
    name: O,
    locale: y
  } = r;
  G(O, y);
  const [E, c] = e(null), [n, a] = e(!1), [M, S] = e(null), [T, i] = e([null, null]), F = f(null), H = f(null), o = f(null), [L, I] = e(0);
  w(() => {
    I(n && o.current ? o.current?.offsetHeight : 0);
  }, [n]);
  const R = (b) => {
    s([null, null]), i([null, null]), a(!0), c(Q.StartDate), b.stopPropagation();
  }, N = u || ([_.MonthRangePicker, _.MonthSelector].includes(l) ? J : K), U = q(() => ({
    dataTrackId: t,
    displayCalendar: n,
    localeDatePicker: r,
    error: d,
    warning: A,
    success: x,
    notice: C,
    setDisplayCalendar: a,
    datePickerType: l,
    withShortcut: m,
    activeShortcut: M,
    setActiveShortcut: S,
    activeInput: E,
    setActiveInput: c,
    handleReset: R,
    minDate: D,
    maxDate: v,
    dates: p,
    previousDates: T,
    setPreviousDates: i,
    format: N,
    onChange: s,
    position: P ?? "left",
    isReset: h,
    refStartDate: F,
    refEndDate: H,
    refContainer: o,
    calendarHeight: L
  }), [t, n, r, d, A, x, C, a, p, T, i, u, s, l, m, M, S, E, c, R, D, v, P, h, F, H, o, L]);
  return /* @__PURE__ */ j(g.Provider, { value: U, children: k });
};
export {
  tt as DatePickerProvider,
  $ as useDatePickerContext
};
